import React, { memo, useEffect, useState } from 'react';

import './_overrides.scss';
import { Search, Row, Column } from '@carbon/react';
import { Checkmark } from '@carbon/react/icons';

const Empty20 = () => {
  return <span style={{ width: '20px' }}></span>;
};

export const CheckedItem = ({ checked, text }) => {
  return (
    <>
      {checked ? <Checkmark size={20} /> : <Empty20 />}
      {text}
    </>
  );
};

export const SearchBar = memo(
  ({
    labelText = '',
    searchChanged = () => {},
    debounceTime = 500,
    children,
  }) => {
    // debounc search input digga
    const [text, setText] = useState();

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
      if (text === undefined) {
        searchChanged('');
      } else {
        const delayDebounceFn = setTimeout(() => {
          // now set the filter with the search text
          searchChanged(text);
        }, debounceTime);

        return () => clearTimeout(delayDebounceFn);
      }
    }, [text]);

    return (
      <Row>
        <Column>
          <div className={`${children ? 'search_with_overflows' : ''}`}>
            <Search
              onChange={(e) => setText(e.target.value)}
              labelText={labelText}
              autoComplete="nothing"
              placeholder={labelText}
              size="lg"
            />
            {children}
          </div>
        </Column>
      </Row>
    );
  }
);
